export default "__VITE_ASSET__DB$iwx2t__"